import { ScrollElementIdEnumType } from 'types/ScrollElementId';
import {
	CHANGE_VIEW_ID,
	CLOSE_OFF_CANVAS,
	OPEN_OFF_CANVAS,
	REQUEST_RESTORE_LAST_SCROLL_POSITION,
	REQUEST_SAVE_SCROLL_POSITION,
	REQUEST_VIEW,
	REQUEST_VIEW_FAILURE,
	REQUEST_VIEW_LOADING,
	REQUEST_VIEW_SUCCESS,
} from './view.actionTypes';

export const actionCreators = {
	doChangeViewID: (routesViewID: string) => ({
		type: CHANGE_VIEW_ID,
		viewID: routesViewID,
	}),
	doOpenOffCanvas: () => ({
		type: OPEN_OFF_CANVAS,
	}),
	doCloseOffCanvas: () => ({
		type: CLOSE_OFF_CANVAS,
	}),
	doRequestView: (view: string, params?: any) => ({
		type: REQUEST_VIEW,
		view,
		params,
	}),
	doRequestViewLoading: (view: string, status: boolean) => ({
		type: REQUEST_VIEW_LOADING,
		view,
		status,
	}),
	doRequestViewSuccess: (view: string) => ({
		type: REQUEST_VIEW_SUCCESS,
		view,
	}),
	doRequestViewFailure: (view: string) => ({
		type: REQUEST_VIEW_FAILURE,
		view,
	}),
	doSaveScrollPosition: (scrollElementId: ScrollElementIdEnumType | undefined, position: number) => ({
		type: REQUEST_SAVE_SCROLL_POSITION,
		scrollElementId,
		position,
	}),
	doRestoreLastScrollPosition: (scrollElementId?: ScrollElementIdEnumType) => ({
		type: REQUEST_RESTORE_LAST_SCROLL_POSITION,
		scrollElementId,
	}),
};

export type ViewActionType =
	| ReturnType<typeof actionCreators.doChangeViewID>
	| ReturnType<typeof actionCreators.doOpenOffCanvas>
	| ReturnType<typeof actionCreators.doCloseOffCanvas>
	| ReturnType<typeof actionCreators.doRequestView>
	| ReturnType<typeof actionCreators.doRequestViewLoading>
	| ReturnType<typeof actionCreators.doRequestViewSuccess>
	| ReturnType<typeof actionCreators.doRequestViewFailure>
	| ReturnType<typeof actionCreators.doSaveScrollPosition>
	| ReturnType<typeof actionCreators.doRestoreLastScrollPosition>;
